function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

export default function (target) {
  for (var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  function merge(_ref) {
    var state = _ref.state,
        resolve = _ref.resolve;

    if (!resolve.isTag(target, 'state')) {
      throw new Error('Cerebral operator.merge: You have to use the STATE TAG as first argument');
    }

    state.merge.apply(state, [resolve.path(target)].concat(_toConsumableArray(values.map(function (value) {
      if (resolve.isTag(value)) {
        return resolve.value(value);
      }

      return Object.keys(value).reduce(function (currentValue, key) {
        currentValue[key] = resolve.value(value[key]);
        return currentValue;
      }, {});
    }))));
  }

  merge.displayName = 'operator.merge(' + String(target) + ', ' + values.map(function (value) {
    return String(value);
  }).join(',') + ')';
  return merge;
}